import { rootRoute } from "@/routes";
import { Footer, NavBar } from "@/shared/ui/composites";
import { VStack } from "@/shared/ui/primitives";
import { createRoute, redirect } from "@tanstack/react-router";
import { CTASection } from "./ui/CTASection";
import { DifferentiationSection } from "./ui/DifferentiationSection";
import { FAQSection } from "./ui/FAQSection";
import { FeaturesSection } from "./ui/FeaturesSection";
import { HeroSection } from "./ui/HeroSection";
import { PainPointsSection } from "./ui/PainPointsSection";
import { SolutionSection } from "./ui/SolutionSection";
import { TargetSection } from "./ui/TargetSection";
import { TrustSection } from "./ui/TrustSection";

const Desktop = () => {
	return (
		<VStack className="w-full bg-bg-weak relative overflow-hidden">
			<NavBar />
			<VStack className="w-full max-w-[1200px] mx-auto gap-[60px] md:gap-[100px] pt-[100px] md:pt-[160px] px-[20px] md:px-[60px]">
				<HeroSection />
				{/* <ChatSection /> */}
				<PainPointsSection />
				<SolutionSection />
				<FeaturesSection />
				<DifferentiationSection />
			</VStack>
			<VStack className="w-full py-[60px] md:py-[100px]">
				<TrustSection />
			</VStack>
			<VStack className="w-full max-w-[1200px] mx-auto gap-[60px] md:gap-[100px] pb-[60px] md:pb-[100px] px-[20px] md:px-[60px]">
				<TargetSection />
				<FAQSection />
				<CTASection />
			</VStack>
			<Footer />
		</VStack>
	);
};

export const homeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/",
	component: Desktop,
	beforeLoad: () => {
		const returnUrl = sessionStorage.getItem("oauth_return_url");
		if (returnUrl) {
			throw redirect({ to: returnUrl });
		}
	},
});
